import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-208b74cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selection-actions" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Không có mục để chọn.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Checkbox, {
        modelValue: _ctx.tatCa,
        binary: true,
        "onUpdate:modelValue": _ctx.chonTatCa,
        disabled: _ctx.disabled || !_ctx.options.length
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
      _createElementVNode("span", null, "Chọn tất cả — " + _toDisplayString(_ctx.modelValue.length) + "/" + _toDisplayString(_ctx.options.length) + " " + _toDisplayString(_ctx.danhTu), 1),
      _createVNode(_component_Button, {
        label: "Bỏ chọn tất cả",
        class: "p-button-text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.capNhat([]))),
        disabled: _ctx.disabled || !_ctx.modelValue.length
      }, null, 8, ["disabled"])
    ]),
    (_ctx.tatCa && !_ctx.moChiTiet)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          value: [{ten: 'Tất cả ' + _ctx.danhTu, soLuong: _ctx.options.length}],
          showGridlines: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "ten",
              header: "Đã chọn"
            }),
            _createVNode(_component_Column, {
              field: "soLuong",
              header: "Số lượng"
            }),
            _createVNode(_component_Column, { header: "Chi tiết" }, {
              body: _withCtx(() => [
                _createVNode(_component_Button, {
                  label: "Xem danh sách",
                  class: "p-button-text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moChiTiet = true))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          value: _ctx.options,
          paginator: true,
          rows: 10,
          rowsPerPageOptions: [10,20,50],
          filters: _ctx.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
          globalFilterFields: [_ctx.labelField,_ctx.valueField],
          stripedRows: "",
          showGridlines: "",
          currentPageReportTemplate: "{first}-{last} / {totalRecords} mục"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters.global.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.global.value) = $event)),
              placeholder: 'Tìm ' + _ctx.danhTu
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          empty: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Chọn",
              headerStyle: "width:4rem"
            }, {
              body: _withCtx((row) => [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.daChon.has(row.data[_ctx.valueField]),
                  binary: true,
                  "onUpdate:modelValue": value => _ctx.chonDong(row.data[_ctx.valueField], value),
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: _ctx.valueField,
              header: "ID",
              sortable: "",
              headerStyle: "width:6rem"
            }, null, 8, ["field"]),
            _createVNode(_component_Column, {
              field: _ctx.labelField,
              header: _ctx.danhTu,
              sortable: ""
            }, null, 8, ["field", "header"])
          ]),
          _: 1
        }, 8, ["value", "filters", "globalFilterFields"]))
  ]))
}